module.exports = __webpack_public_path__ + "media/images/icons/icon_youtube-c684f0674ee0cd92603356a461783b3b.png";